import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import BulkOperationReportIcon from '../../Components/Icons/BulkOperationReportIcon'
import CalendarIcon from '../../Components/Icons/CalenderIcon'
import ContentIngestionReportIcon from '../../Components/Icons/ContentIngestionReportIcon'
import { PAGES_ROUTES } from '../../Constants'
import updateTagMetaData from '../../Helpers/updateTagMetaData'
import './DataMigrationReports.scss'

const reportCards = [
  {
    title: 'Content Ingestion Report',
    description: 'Ingestion data overview and export panel.',
    to: `/${PAGES_ROUTES.Reports}/content-ingestion-report`,
    icon: <ContentIngestionReportIcon />,
  },
  {
    title: 'Bulk Operations Reports',
    description: 'History of performed bulk operations.',
    to: `/${PAGES_ROUTES.Reports}/bulk-operations-report`,
    icon: <BulkOperationReportIcon />,
  },
  {
    title: 'Publishing Monitoring Report',
    description: 'Centralized metrics for automated publishing events.',
    to: `/${PAGES_ROUTES.Reports}/publishing-monitoring-report`,
    icon: <CalendarIcon />,
  },
]

const ReportsList = () => {
  const location = useLocation()

  useEffect(() => {
    updateTagMetaData({ title: 'Reports' })
    return () => updateTagMetaData({})
  }, [])

  return (
    <div className='reportsPage'>
      <h1>Reports</h1>
      <div className='reportsContainer'>
        {reportCards.map(({ title, description, to, icon }) => (
          <Link
            key={title}
            to={{ pathname: to }}
            state={{ fromPage: location.pathname }}
            className='reportCard'
          >
            <div style={{ marginBottom: '4px', marginTop: '10px' }}>{icon}</div>
            <div>
              <p className='reportTitle'>{title}</p>
              <p className='reportDescription'>{description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default React.memo(ReportsList)
